import React, { Component } from "react";

import axios from "axios";
import $ from "jquery";
import { Link } from "react-router-dom";
import swal from "sweetalert";

import { PaystackConsumer } from "react-paystack";

import Header from "./common/Header";
import Sidebar from "./common/Sidebar";
import Avatar from "./assets/img/default-user-avatar.png";

var _fname,
  _lname,
  _phone,
  _mstatus,
  _address,
  _dob,
  _password,
  _kfullname,
  _kemail,
  _kphone,
  _kaddress;

export class Profile extends Component {
  constructor(props) {
    super(props);
    // let { user } = this.props.appstate;
    this.state = {
      token: localStorage["appState"]
        ? JSON.parse(localStorage["appState"]).user.token
        : "",
      user: [],
      imageSource: "",
      file: null,
      payment_ref: "",
      auth_code: "",
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    // //console.log(id);
    this.getUser();
  }

  getUser() {
    axios
      .get(
        `${axios.defaults.baseURL}/user/${
          JSON.parse(localStorage["appState"]).user.id
        }`,
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
          },
        }
      )
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          this.setState({ user: json.data.user[0] });
          // } else alert("Cannot Fetch Data!");
        } else swal("Oops!", "Cannot Fetch Data!", "error");
      })
      .catch((error) => {
        console.error(`An Error Occured! ${error}`);
      });
  }

  handleUpdate = (e) => {
    e.preventDefault();

    $("#update-profile")
      .attr("disabled", "disabled")
      .html(
        '<i class="fa fa-spinner fa-spin fa-1x fa-fw"></i><span class="sr-only">Loading...</span>'
      );

    var formData = new FormData();
    formData.append("fname", _fname.value);
    formData.append("lname", _lname.value);
    formData.append("phone", _phone.value);
    formData.append("image", this.state.file);
    formData.append("password", _password.value);
    formData.append("mstatus", _mstatus.value);
    formData.append("address", _address.value);
    formData.append("dob", _dob.value);
    formData.append("kfullname", _kfullname.value);
    formData.append("kemail", _kemail.value);
    formData.append("kphone", _kphone.value);
    formData.append("kaddress", _kaddress.value);

    //console.log(formData);

    axios({
      method: "post",
      url: `${axios.defaults.baseURL}/user/${
        JSON.parse(localStorage["appState"]).user.id
      }`,
      data: formData,
      headers: {
        Authorization: `Bearer ${this.state.token}`,
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        const {
          id,
          fname,
          lname,
          email,
          phone,
          mstatus,
          address,
          dob,
          kfullname,
          kemail,
          kphone,
          kaddress,
        } = json.data.user;
        const { token } = json.data.token;
        let userData = {
          id,
          fname,
          lname,
          email,
          phone,
          mstatus,
          address,
          dob,
          kfullname,
          kemail,
          kphone,
          kaddress,
          token,
          timestamp: new Date().toString(),
        };
        let appState = {
          isLoggedIn: true,
          user: userData,
        };
        // save app state with user date in local storage
        localStorage["appState"] = JSON.stringify(appState);
        this.setState({
          isLoggedIn: appState.isLoggedIn,
          user: appState.user,
          token: appState.token,
        });

        if (json.data.success === true) {
          swal("Updated!", "" + json.data.message, "success", {
            button: false,
            timer: 1500,
          });
          $("#update-profile").removeAttr("disabled").html("Update Profile");
          // redirect home
          // this.props.history.push("/my-account");
        } else {
          // alert(json.data.message);
          swal("Alert!", "" + json.data.message, "warning");
          $("#update-profile").removeAttr("disabled").html("Update Profile");
        }
      })
      .catch((error) => {
        // alert("An Error Occured!" + error);
        //console.log(error.response.data);
        if (error.response.data.message.fname === "") {
          swal("Warning!", "" + error.response.data.message.fname, "warning");
        } else {
          swal("Warning!", "Please fill all fields", "warning");
        }
        $("#update-profile").removeAttr("disabled").html("Update Profile");
      });
  };

  // onChange(e) {
  //   this.setState({file:e.target.files[0]});
  // }

  uploadPhoto = (e) => {
    this.photoUpload.click();
  };

  onChange = (event) => {
    this.setState({
      imageSource: "",
      imageData: "",
      file: event.target.files[0],
    });
    const file = event.target.files[0];
    //console.log(file);

    if (file) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event) => {
        this.setState({
          imageSource: event.target.result,
          imageData: file,
        });
      };
    }
  };

  render() {
    $("#fname-input").attr("value", this.state.user.fname);
    $("#lname-input").attr("value", this.state.user.lname);
    // $("#email-input").attr("value", this.state.user.email);
    $("#phone-input").attr("value", this.state.user.phone);
    $("#mstatus-input").attr("value", this.state.user.mstatus);
    $("#address-input").attr("value", this.state.user.address);
    $("#dob-input").attr("value", this.state.user.dob);
    $("#kfullname-input").attr("value", this.state.user.kfullname);
    $("#kemail-input").attr("value", this.state.user.kemail);
    $("#kphone-input").attr("value", this.state.user.kphone);
    $("#kaddress-input").attr("value", this.state.user.kaddress);


    const configNGN = {
      // reference: (new Date()).getTime(),
      email: this.state.user.email,
      // plan: this.state.plan,
      amount: "10000",
      currency: "NGN",
      publicKey: 'pk_live_68d2b6e9edacd11392f5548db9047ffb4911b39d',
      // publicKey: "pk_test_3a1c9194d014f2629abda6e0c3f22cb931141cf4",
    };

    const componentPropsNGN = {
      ...configNGN,
      text: "Bank Card Update",
      onSuccess: (response) => {

        // console.log(response);

        this.setState({
          payment_ref: response.trxref
        });

        axios({
            method: 'get',
            url: `https://api.paystack.co/transaction/verify/${this.state.payment_ref}`,
            headers: {'Authorization': `Bearer sk_live_5299c2d2e25663425657490251d1cec7d8c206aa`, 'Content-Type': 'application/json' }
            // headers: {'Authorization': `Bearer sk_test_2e3a16e2c572cbcfd59cbc761105f58b7a34e90d`, 'Content-Type': 'application/json' }
            })
            .then(response => {
                //console.log(response);
                return response;
            })
            .then(json => {
                  this.setState({
                    auth_code: json.data.data.authorization.authorization_code
                  });

                  swal("Success!", "Card Update was Successful!", "success", {
                    button: false,
                    timer: 1500,
                  });
          
                  var formData = new FormData();
                  formData.append("auth_code", this.state.auth_code);
                  formData.append("user_id", JSON.parse(localStorage["appState"]).user.id);
          
                  axios({
                      method: 'post',
                      url: `${axios.defaults.baseURL}/update-user-card`,
                      data: formData,
                      headers: {'Authorization': `Bearer ${JSON.parse(localStorage["appState"]).user.token}`, 'Content-Type': 'multipart/form-data' }
                      })
                      .then(response => {
                          //console.log(response);
                          return response;
                      })
                      .then(json => {
                          if (json.data.success) {
                            // swal("Success!", "" + json.data.message, "success", {
                            //   button: false,
                            //   timer: 1500,
                            // });
                          // redirect to plans
                          this.props.history.push("/my-account");
                          } else {
                          swal("Failed", ""+ json.data.message, "error");
                          }
                      })
                      .catch(error => {
                          // alert("An Error Occured!" + error);
                          let res = ("An Error Occured");
                          swal("Error!", "" + res, "error", {
                          button: false,
                          // timer: 1500
                          });
                          //console.log(`${formData} ${error}`);
                      });
            });
      },
      onClose: () => null,
    };

    return (
      <div id="app" className="bg-gray-200">
        <div className="dashboard-page">
          <div className="private-layout">
            <div className="app-wrapper">
              <Sidebar />
              <Header />
              <div id="main-app" className="position-relative">
                <div className="container mt-4">
                  <div data-v-4c22b934="">
                    <div data-v-4c22b934="" id="profile-page">
                      <div className="page-title">
                        <div className="row text-primary py-2 pt-4">
                          <div className="col-10">
                            <div
                              className="user-welcome"
                              style={{ overflow: "hidden" }}
                            >
                              <div className="wrapper d-flex">
                                <h4 className="d-inline-block">My Profile</h4>
                              </div>
                            </div>
                          </div>
                          <div className="text-right col-2"></div>
                        </div>
                      </div>
                      <div className="pb-5">
                        <div className="row">
                          <div className="col-12">
                            <div className="wrapper dash-card bg-white">
                              <div className="p-4 text-center">
                                <img
                                  src={
                                    this.state.imageSource
                                      ? this.state.imageSource
                                      : this.state.user.image
                                      ? this.state.user.image
                                      : Avatar
                                  }
                                  id="user-logo"
                                  className="shadow-xl user-avatar"
                                />
                                <br />
                                <br />
                                <p
                                  role="button"
                                  onClick={this.uploadPhoto}
                                  style={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                >
                                  Change Photo
                                </p>
                              </div>
                              <hr className="mt-0"></hr>
                              <div className="px-4">
                                <h5 className="mb-0">Personal Data</h5>
                              </div>
                              <form
                                id="reg"
                                action=""
                                onSubmit={this.handleUpdate}
                                method="post"
                              >
                                <input
                                  ref={(input) => (this.photoUpload = input)}
                                  onChange={this.onChange}
                                  autoComplete="off"
                                  id="image-input"
                                  name="image"
                                  type="file"
                                  hidden
                                />
                                <div className="p-4">
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        First Name
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_fname = input)}
                                          id="fname-input"
                                          name="fname"
                                          type="text"
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Last Name
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_lname = input)}
                                          id="lname-input"
                                          name="lname"
                                          type="text"
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Telphone
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_phone = input)}
                                          id="phone-input"
                                          name="phone"
                                          type="text"
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Marital Status
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <select
                                          ref={(input) => (_mstatus = input)}
                                          id="mstatus-input"
                                          name="mstatus"
                                          type="text"
                                          aria-required="true"
                                          className="form-control"
                                        >
                                          <option value="Single">Single</option>
                                          <option value="Married">
                                            Married
                                          </option>
                                          <option value="Divorced">
                                            Divorced
                                          </option>
                                          <option value="Widow">Widow</option>
                                          <option value="Widower">
                                            Widower
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Residential Address
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_address = input)}
                                          id="address-input"
                                          name="address"
                                          type="text"
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Date of Birth
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_dob = input)}
                                          id="dob-input"
                                          name="dob"
                                          type="date"
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>

                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Password
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_password = input)}
                                          id="password-input"
                                          name="password"
                                          type="text"
                                          aria-required="true"
                                          className="form-control"
                                          placeholder="Enter New Password (leave blank to maintain old password)"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                </div>
                                <hr className="mt-0"></hr>
                                <div className="px-4">
                                  <h5 className="mb-0">Next of Kin</h5>
                                </div>
                                <div className="p-4">
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Full Name
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_kfullname = input)}
                                          id="kfullname-input"
                                          name="kfullname"
                                          type="text"
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Email
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_kemail = input)}
                                          id="kemail-input"
                                          name="kemail"
                                          type="text"
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Telephone
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_kphone = input)}
                                          id="kphone-input"
                                          name="kphone"
                                          type="text"
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset className="form-group">
                                    <div className="form-row">
                                      <legend
                                        tabindex="-1"
                                        className="col-sm-4 col-lg-3 bv-no-focus-ring col-form-label"
                                      >
                                        Address
                                      </legend>
                                      <div
                                        tabindex="-1"
                                        role="group"
                                        className="bv-no-focus-ring col"
                                      >
                                        <input
                                          ref={(input) => (_kaddress = input)}
                                          id="kaddress-input"
                                          name="kaddress"
                                          type="text"
                                          aria-required="true"
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </fieldset>
                                  <div className="text-center">
                                    <button
                                      id="update-profile"
                                      type="submit"
                                      className="btn btn-primary my-4"
                                    >
                                      Update Profile
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="page-title">
                        <div className="row text-primary py-2 pt-4">
                          <div className="col-10">
                            <div
                              className="user-welcome"
                              style={{ overflow: "hidden" }}
                            >
                              <div className="wrapper d-flex">
                                <h4 className="d-inline-block">
                                  Update Payment Card
                                </h4>
                              </div>
                            </div>
                          </div>
                          <div className="text-right col-2"></div>
                        </div>
                      </div>
                      <div className="pb-5">
                        <div className="row">
                          <div className="col-12">
                            <div className="wrapper dash-card bg-white">
                              <div className="p-4 text-center">
                                <div className="text-center">
                                  <br/><br/>
                                  <p>
                                    Once you activate a plan, the bank card used for payment is automatically linked to your Evest account and will be used for subsequent payments. If you wish to change the card at anytime click the button below.
                                  </p>
                                  <PaystackConsumer {...componentPropsNGN}>
                                  {({ initializePayment }) => (
                                      <button
                                    type="button"
                                      onClick={() =>
                                        swal(
                                          "You will be charged ₦100.00 to update your card. Are you sure you want to continue?",
                                          {
                                            buttons: {
                                              cancel: "No, Cancel",
                                              catch: {
                                                text: "Yes, Continue",
                                                value: "catch",
                                              },
                                            },
                                          }
                                        ).then((value) => {
                                          switch (value) {
                                            case "catch":
                                              initializePayment();
                                              break;

                                            default:
                                          }
                                        })
                                      }
                                      id="submit"
                                      name="subscribe-button"
                                      className="btn btn-primary my-4"
                                    >
                                      Click to Update Bank Card
                                    </button>)}
                                </PaystackConsumer>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Profile;
